<template>
<modal name="credit-records-modal" transition="pop-out" class="popup-win" width="50%" height="auto">
  <div class="box">
    <div class="box-part" id="bp-left">
      <div class="partition" id="partition-register">
        <a class="closebtn" @click="closeNav">&times;</a>
        <div class="partition-title">سوابق خرید</div>
        <div class="partition-form">
          <template v-if="list.length != 0">
            <div v-for="(elm, index) in list" class="item" :key="index">
              <span>واریزی به مبلغ {{ elm.Amount | comma }} در تاریخ {{ elm.Created_at | moment }} انجام گردیده.</span>
            </div>
          </template>
          <template v-else>
            <div class="item">
              <span>در حال حاضر سابقه‌ای وجود ندارد</span>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</modal>
</template>

<script>
import moment from 'moment-jalaali';

export default {
    name: 'CreditRecordsModal',
    props: ['list'],
    filters: {
        // will show the date like 'Jun 24th 2020'
        moment: (date) => {
            return moment(date).format('jDD/jMMMM/jYYYY');
        }
    },
    methods: {
        closeNav() {
            this.$modal.hide('credit-records-modal');
        },
        close() {
            this.$modal.hide('credit-records-modal');
        }
    }
}
</script>

<style scoped>
.popup-win {
  padding-left: 50%;
}
.box {
    direction: ltr;
    background: #232f7e;
    overflow: hidden;
    height: fit-content;
    border-radius: 2px;
    box-sizing: border-box;
    box-shadow: 0 0 40px black;
    color: #fff;
    font-size: 0;
}
.box .closebtn {
  position: absolute;
  top: 0pt;
  left: 20px;

  cursor: pointer;
  font-size: 2rem;
}
.box .form-control {
  margin-bottom: .5rem;
}
.box .box-part {
    display: inline-block;
    position: relative;
    vertical-align: top;
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    direction: rtl;
}
.box .box-messages {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
}
.box .box-error-message {
    position: relative;
    overflow: hidden;
    box-sizing: border-box;
    height: 0;
    line-height: 32px;
    padding: 0 12px;
    text-align: center;
    width: 100%;
    font-size: 11px;
    color: white;
    background: #F38181;
}
.box .partition {
    width: 100%;
    height: 100%;
}
.box .partition .partition-title {
      box-sizing: border-box;
      padding: 20px 0 10px;
      width: 100%;
      text-align: center;
      font-size: 20px;
      font-weight: 300;
}
.box .partition .partition-form {
      padding: 0 20px;
      box-sizing: border-box;
}
  
.box .partition input[type=email],
.box .partition input[type=password] {
    display: block;
    box-sizing: border-box;
    margin: 10px auto 15px;
    width: 100%;
    font-size: 12px;
    line-height: 2;
    border: 0;
    border-bottom: 1px solid #DDDEDF;
    padding: 4px 8px;
    font-family: inherit;
    transition: 0.5s all;
    outline: none;

    text-align: left;
    direction: ltr;
}
.box .partition button {
    background: white;
    border-radius: 4px;
    box-sizing: border-box;
    padding: 10px;
    min-width: 140px;
    margin-top: 8px;
    color: #fff;
    cursor: pointer;
    border: 1px solid #DDDEDF;
    text-transform: uppercase;
    transition: 0.1s all;
    font-size: 10px;
    outline: none;
}
.box .partition button:hover {
      border-color: mix(#28a745, black, 90%);
      color: mix(#111, black, 80%);
}
.box .partition .large-btn {
    width: 100%;
    margin: 10px auto 15px;
    color: #fff;
    border-color: #28a745;
    background-color: #2ad85f;
    font-size: 16px;
}
.box .partition .large-btn:hover {
    color: #858585 !important;
}
.autocomplete-fix {
    position: absolute;
    visibility: hidden;
    overflow: hidden;
    opacity: 0;
    width: 0;
    height: 0;
    left: 0;
    top: 0;
}
.pop-out-enter-active,
.pop-out-leave-active {
  transition: all 0.5s;
}
.pop-out-enter,
.pop-out-leave-active {
  opacity: 0;
  transform: translateY(24px);
}

.partition-form .item {
    height: 50px;
    width: calc(100% - 20px);

    margin: 10px;
    color: #fff;
    background-color: #232f7e;
    /* background-color: #fff; */

    border-radius: 5px;
    border: 1px solid #aaa;

    padding: 12px;

    text-align: center;
    font-size: 12px !important;

    display: flex;
}
.partition-form .item span {
  width: calc(100% - 30px);
}
#partition-register {
  overflow: scroll;
}

.rmv-btn {
    font-size: 20px;

    margin: auto;
    margin-top: -15px;
    margin-left: -5px;
    margin-right: 10px;
}
.box input {
    height: calc(1.5em + 1.25rem + 2px);

    text-align: center;
    font-size: 1rem;
    
    color: #fff;
    background-color: #232f7e;

    border-radius: 15px;
    border: 1px solid #000a5442;
    box-shadow: inset 2px 2px 4px 3px #0d1c84;
}
.box input:-webkit-autofill,
.box input:-webkit-autofill:hover, 
.box input:-webkit-autofill:focus {
    color: #fff !important;
    -webkit-text-fill-color: #fff;

    background-color: #232f7e !important;
    box-shadow:  0 0 0px 1000px #2e3a8a inset;
    -webkit-box-shadow: 0 0 0px 1000px #2e3a8a inset;
}
.box ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #fff;
    opacity: 1; /* Firefox */
}
.box :-ms-input-placeholder,
.box ::-ms-input-placeholder { /* Microsoft Edge */
    color: #fff;
}

/* button */
.box .partition .large-btn {
    height: calc(1.5em + 1.25rem + 2px);
    width: 100%;

    font-size: 1rem;
    font-weight: 700;

    border-radius: 15px;
    background-color: #2ad85f;
}
</style>